export default {
	MAIN: 'main',
	CHILD: 'child',
}
